import React from "react";
import {NavLink} from "react-router-dom";
import { Home, File, Users, ShoppingCart, DollarSign, PlusCircle, BookOpen, User, Settings, Layers } from 'react-feather';

export class Sidebar extends React.Component {

    render() {
        return (
          <nav className={this.props.show ? "col-md-2 bg-light sidebar" : "col-md-2 d-none d-md-block bg-light sidebar"}>
            <div className="sidebar-sticky" onClick={this.props.toggleSidebar}>
              <ul className="nav flex-column">
                <li className="nav-item">
                  <NavLink to={"/dashboard"} activeClassName={"active"} className="nav-link">
                    <Home className="feather" size={16}/>
                    Dashboard <span className="sr-only">(current)</span>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to={"/orders"} activeClassName={"active"} className="nav-link">
                    <File className="feather" size={16}/>
                    Orders
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to={"/products"} activeClassName={"active"} className="nav-link">
                    <ShoppingCart className="feather" size={16}/>
                    Products
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to={"/pricelists"} activeClassName={"active"} className="nav-link">
                    <DollarSign className="feather" size={16}/>
                    Price Lists
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to={"/catalogues"} activeClassName={"active"} className="nav-link">
                    <BookOpen className="feather" size={16}/>
                    Catalogues
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to={"/categories"} activeClassName={"active"} className="nav-link">
                    <Layers className="feather" size={16}/>
                    Categories
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to={"/customers"} activeClassName={"active"} className="nav-link">
                    <Users className="feather" size={16}/>
                    Customers
                  </NavLink>
                </li>
                {/* <li className="nav-item">
                  <NavLink to={"/reports"} activeClassName={"active"} className="nav-link">
                    <BarChart2 className="feather" size={16}/>
                    Reports
                  </NavLink>
                </li> */}
              </ul>

              <h6 className="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
                <span>Other</span>
                <a className="d-flex align-items-center text-muted">
                  <Settings className="feather" size={16}/>
                </a>
              </h6>
              <ul className="nav flex-column mb-2">
                <li className="nav-item">
                  <NavLink to={"/profile"} activeClassName={"active"} className="nav-link">
                    <User className="feather" size={16}/>
                    Profile
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to={"/settings/general"} 
                    isActive={(match, loc) => {return loc.pathname.includes('settings')}} 
                    activeClassName={"active"} 
                    className="nav-link"
                  >
                    <Settings className="feather" size={16}/>
                    Settings
                  </NavLink>
                </li>
              </ul>
            </div>
          </nav>
        );
    }
}
